export const IMAGE_PLACEHOLDER_PATH = 'assets/images/image-placeholder.png';
export const EVENT_IMAGE_PLACEHOLDER_PATH = 'assets/images/event-image-placeholder.png';
export const DYNAMIC_PAGE_LINK_PREFIX = '/pages/dynamic/';
export const VIEWER_PAGE_LINK_PREFIX = '/pages/page-viewer/';
export const TEMPLATES_BUILDER_PAGE_LINK_PREFIX = '/templates-builder/template-editor/';
